module.exports = __webpack_public_path__ + "static/media/teacher.67e0faa7.jpg";